(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ask-question"] && !Shopify.designMode) return;
  try {
    class AskQuestionForm extends HTMLElement {
  constructor() {
    super();
    this.emailInput = this.querySelector('[data-email-input]');
    this.questionInput = this.querySelector('[data-question-input]');

    this.handleEngage = this.handleEngage.bind(this);
  }

  connectedCallback() {
    this.questionInput?.addEventListener('focus', this.handleEngage);
    this.emailInput?.addEventListener('focus', this.handleEngage);

    if (this.emailInput?.value) {
      this.setAttribute('data-form-engaged', '');
    }
  }

  disconnectedCallback() {
    this.questionInput?.removeEventListener('focus', this.handleEngage);
    this.emailInput?.removeEventListener('focus', this.handleEngage);
  }

  handleEngage() {
    this.setAttribute('data-form-engaged', '');
  }
}

if (!customElements.get('ask-question-form')) {
  customElements.define('ask-question-form', AskQuestionForm);
}
  } catch(e) { console.error(e); }
})();

})();
